import { httpService } from '@/services/HttpService';

class VirtualMachineDetailsService {
  getVirtualMachineDetails(workspaceId: number, regionId: number, virtualMachineId: number): Promise<any> {
    return httpService.get(`workspaces/${workspaceId}/regions/${regionId}/virtual_machines/${virtualMachineId}`);
  }
  editVirtualMachineDetails(
    workspaceId: number,
    regionId: number,
    virtualMachineId: number,
    detailsData: any
  ): Promise<any> {
    return httpService.put(
      `workspaces/${workspaceId}/regions/${regionId}/virtual_machines/${virtualMachineId}`,
      detailsData
    );
  }
  powerOffVirtualMachine(workspaceId: number, regionId: number, virtualMachineId: number): Promise<any> {
    return httpService.post(
      `workspaces/${workspaceId}/regions/${regionId}/virtual_machines/${virtualMachineId}/power_off`,
      ''
    );
  }
  deleteVirtualMachine(workspaceId: number, regionId: number, virtualMachineId: number): Promise<any> {
    return httpService.delete(`workspaces/${workspaceId}/regions/${regionId}/virtual_machines/${virtualMachineId}`, '');
  }
  powerOnVirtualMachine(workspaceId: number, regionId: number, virtualMachineId: number): Promise<any> {
    return httpService.post(
      `workspaces/${workspaceId}/regions/${regionId}/virtual_machines/${virtualMachineId}/power_on`,
      ''
    );
  }
  suspendVirtualMachine(workspaceId: number, regionId: number, virtualMachineId: number): Promise<any> {
    return httpService.post(
      `workspaces/${workspaceId}/regions/${regionId}/virtual_machines/${virtualMachineId}/suspend`,
      ''
    );
  }
  restartVirtualMachine(workspaceId: number, regionId: number, virtualMachineId: number): Promise<any> {
    return httpService.post(
      `workspaces/${workspaceId}/regions/${regionId}/virtual_machines/${virtualMachineId}/restart`,
      ''
    );
  }
  accessTheConsole(workspaceId: number, regionId: number, virtualMachineId: number): Promise<any> {
    return httpService.post(
      `workspaces/${workspaceId}/regions/${regionId}/virtual_machines/${virtualMachineId}/console_access`,
      ''
    );
  }
  createSnapshot(workspaceId: number, regionId: number, virtualMachineId: number): Promise<any> {
    return httpService.post(
      `workspaces/${workspaceId}/regions/${regionId}/virtual_machines/${virtualMachineId}/snapshot`,
      ''
    );
  }
  getSnapshot(workspaceId: number, regionId: number, virtualMachineId: number): Promise<any> {
    return httpService.get(
      `workspaces/${workspaceId}/regions/${regionId}/virtual_machines/${virtualMachineId}/snapshot`
    );
  }
  restoreSnapshot(workspaceId: number, regionId: number, virtualMachineId: number): Promise<any> {
    return httpService.put(
      `workspaces/${workspaceId}/regions/${regionId}/virtual_machines/${virtualMachineId}/snapshot`,
      ''
    );
  }
  deleteSnapshot(workspaceId: number, regionId: number, virtualMachineId: number): Promise<any> {
    return httpService.delete(
      `workspaces/${workspaceId}/regions/${regionId}/virtual_machines/${virtualMachineId}/snapshot`,
      ''
    );
  }
  getHardware(workspaceId: number, regionId: number, virtualMachineId: number): Promise<any> {
    return httpService.get(
      `workspaces/${workspaceId}/regions/${regionId}/virtual_machines/${virtualMachineId}/hardware`
    );
  }
  updateHardware(workspaceId: number, regionId: number, virtualMachineId: number, data: any): Promise<any> {
    return httpService.put(
      `workspaces/${workspaceId}/regions/${regionId}/virtual_machines/${virtualMachineId}/hardware`,
      data
    );
  }
  getNetworkCards(workspaceId: number, regionId: number, virtualMachineId: number): Promise<any> {
    return httpService.get(`workspaces/${workspaceId}/regions/${regionId}/nics?virtual_machine_id=${virtualMachineId}`);
  }
  getAllNetworkCards(workspaceId: number, regionId: number): Promise<any> {
    return httpService.get(`workspaces/${workspaceId}/regions/${regionId}/nics`);
  }
  getNetworkCard(workspaceId: number, regionId: number): Promise<any> {
    return httpService.get(`workspaces/${workspaceId}/regions/${regionId}/nics/new`);
  }
  createNetworkCard(workspaceId: number, regionId: number, nicData: any): Promise<any> {
    return httpService.post(`workspaces/${workspaceId}/regions/${regionId}/nics`, nicData);
  }
  updateNetworkCard(workspaceId: number, regionId: number, networkCardId: number, nicData: any): Promise<any> {
    return httpService.put(`workspaces/${workspaceId}/regions/${regionId}/nics/${networkCardId}`, nicData);
  }
  deleteNetworkCard(workspaceId: number, regionId: number, networkCardId: number): Promise<any> {
    return httpService.delete(`workspaces/${workspaceId}/regions/${regionId}/nics/${networkCardId}`, '');
  }
  activateBackup(workspaceId: number, regionId: number, virtualMachineId: number): Promise<any> {
    return httpService.post(
      `workspaces/${workspaceId}/regions/${regionId}/virtual_machines/${virtualMachineId}/activate_backup`,
      ''
    );
  }
}

export const virtualMachineDetailsService = new VirtualMachineDetailsService();
